import { profileSystems as defaultProfileSystems } from '../data/mockData';

/** Map legacy/alternate ids (e.g. synego-1) to canonical profile ids used in export logic. */
export const normalizeProfileSystemId = (id) => {
  if (!id) return null;
  if (id === 'schuco') return 'schuco';
  if (id === 'synego' || id === 'synego-1' || String(id).startsWith('synego')) return 'synego';
  return id;
};

/** Dominant profile across saved drawings (one vote per drawing); equal counts default to Schüco. */
export const resolveOrderProfileSystemId = (savedQuotes = []) => {
  const counts = { schuco: 0, synego: 0 };

  savedQuotes.forEach((quote) => {
    const id = normalizeProfileSystemId(quote?.config?.profileSystem);
    if (id === 'schuco' || id === 'synego') {
      counts[id] += 1;
    }
  });

  if (counts.synego > counts.schuco) return 'synego';
  return 'schuco';
};

/** Headline label for the profile block on the VMK spec page. */
export const getProfileSpecLead = (profileSystemId) => {
  const id = normalizeProfileSystemId(profileSystemId);
  if (id === 'synego') return 'Veka';

  const profile = defaultProfileSystems.find((p) => p.id === id);
  if (profile?.id === 'schuco') return 'Schüco';

  return profile?.name || 'Schüco';
};

/** Translation key for profile bullet list on the VMK spec page. */
export const getProfileSpecItemsKey = (profileSystemId) => {
  const id = normalizeProfileSystemId(profileSystemId);
  if (id === 'synego') return 'quote.template.specProfileItemsVeka';
  return 'quote.template.specProfileItemsSchuco';
};

export const getProfileSpecItems = (profileSystemId, t) =>
  t(getProfileSpecItemsKey(profileSystemId), { returnObjects: true }) || [];

export const isProfileSystemSelected = (configProfileId, optionProfileId) =>
  normalizeProfileSystemId(configProfileId) === normalizeProfileSystemId(optionProfileId);
